/**
 * Do not remove any keys!!
 * The shape of this file is to remain the same so that all options are know.
 *
 * If a key does not have a value, set the value to undefined.
 */
module.exports = {
  communityName: "Old Mill Village",
  gtagId: "G-VN4KGPSK7P",
  logo: {
    src: "https://cdn.maxxpm.com/Old Mill Village/om_logo.png",
    alt: "The Brickyard Logo",
  },
  nav: {
    bannerSubtitle: undefined,
    bannerTitle: undefined,
    bannerCTA: undefined,
  },
  footer: {
    address: "989 E Ella Ln",
    cityStateZip: "Heber, UT 84032",
    phone: "(385) 236-5514",
    copyrightYear: "2024",
    logo: "https://cdn.maxxpm.com/Old Mill Village/footer_logo.png",
  },
  listMarkerSrc: "https://cdn.maxxpm.com/Old Mill Village/li_marker.png",
  hasShowingPopup: true,
  home: {
    banner: {
      image: "https://cdn.maxxpm.com/Old Mill Village/DSC_0925.jpg",
      video: undefined,
      title: "Upgraded Smart Townhomes & Apartments",
      subtitle: "We Can't Wait To Welcome You Home!",
      openHouse: {
        start: new Date("2026-08-06T10:00:00.000-06:00"),
        end: new Date("2026-08-06T14:00:00.000-06:00"),
        image: "https://cdn.maxxpm.com/colonyfarms/Updated Photos/1.jpg",
      },
    },
    aboutUs: {
      paragraphs: [
        "Nestled in Heber, Utah, our thoughtfully designed apartments and 3 bed, 2.5 bath townhomes feature state of the art smart home technology for modern convenience. With essential amenities such as Walmart, Heber Valley Hospital, and Wasatch High School less than 2 miles away, residents can enjoy everyday accessibility without sacrificing the tranquility of the surrounding mountains.",
        "Old Mill Village offers more than just a place to live; it's a community designed for comfort and leisure. Whether you're taking advantage of nearby outdoor activities and scenic hikes or unwinding in the comfort of our smart apartments, townhomes, and amenities, Old Mill Village offers the perfect balance of accessibility and serenity in Heber, Utah.",
      ],
      image: {
        src: "https://cdn.maxxpm.com/Old%20Mill%20Village/DJI_0305.jpg",
        alt: "Old Mill Village exterior photo",
      },
    },
    floorplanTitle: "Explore Our Floor Plan and Take a 3D Virtual Tour",
    floorplans: [
      {
        hasImage: true,
        name: "2-Story Steve",
        image: {
          src: "https://cdn.maxxpm.com/Old Mill Village/Steve.jpg",
          alt: "2-Story Steve Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          embeddable: true,
          src: "https://my.matterport.com/show/?m=AzU8CKntVKp",
          title: "3d walkthrough",
        },
      },
      {
        hasImage: true,
        name: "2-Bed 2-Bath",
        image: {
          src: "https://cdn.maxxpm.com/Old Mill Village/Old Mill 2nd Floor 1.png",
          alt: "Old Mill Village 2-Bed 2-Bath Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          embeddable: true,
          src: "https://www.zillow.com/view-imx/d59b07a8-9d94-49a3-a735-3717dc11aa4e?initialViewType=pano&utm_source=dashboard",
          title: "2-Bed 2-Bath 3D Tour",
        },
      },
      {
        hasImage: true,
        name: "1-Bed 1-Bath",
        image: {
          src: "https://cdn.maxxpm.com/Old Mill Village/Old Mill 4th Floor 1.png",
          alt: "Old Mill Village 1-Bed 1-Bath Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          embeddable: true,
          src: "https://www.zillow.com/view-imx/828747e1-ffff-4dd3-ba1c-66bb597664eb?initialViewType=pano&utm_source=dashboard",
          title: "1-Bed 1-Bath 3D Tour",
        },
      },
    ],
    midContainerImage: "https://cdn.maxxpm.com/stockphotos/living room grey couch.jpg",
    imgRow: [
      {
        src: "https://cdn.maxxpm.com/Old%20Mill%20Village/DSC_2882-Enhanced-NR-Edit.jpg",
        alt: "Old Mill Village interior photo",
      },
      {
        src: "https://cdn.maxxpm.com/Old Mill Village/ChatGPT Image May 15, 2026, 09_29_05 AM.png",
        alt: "Old Mill Village exterior photo",
      },
      {
        src: "https://cdn.maxxpm.com/Old Mill Village/DSC_2885-Enhanced-NR.jpg",
        alt: "Old Mill Village interior photo",
      },
    ],
    animalPolicy: {
      img: {
        src: "https://cdn.maxxpm.com/stockphotos/boy+kissing+dog.jpg",
        alt: "Animal policy stock photo",
      },
      policies: [
        "No more than 2 animals are allowed per property",
        "Cats/Dogs: $250/animal*",
        "$50/animal/month for animals under 50lbs*",
        "$75/animal/month for animals 50lbs+*",
        "One-time $75/animal DNA testing fee*",
        "Caged animals: $25/animal/month*",
        "Fish tanks are not permitted",
        "Rabbits and rodents of any kind are not permitted",
      ],
      breedRestrictions: ["Pit Bulls & Staffordshire Terriers", "Doberman Pinschers", "Rottweilers", "Chows", "Great Danes", "Presa Canarios/ Mastiffs", "Akitas", "Alaskan Malamutes", "Huskies", "German Shepherds", "Shar Peis", "Wolf-Hybrids"],
    },
  },
  availability: {
    banner: {
      image: "https://cdn.maxxpm.com/Old Mill Village/DSC_0925.jpg",
      video: undefined,
      title: "Available Units",
      subtitle: "Unit availability is updated often from Monday-Friday during business hours. Evenings and weekends may not reflect accurate availability dates.",
    },
    hasWaitingList: false,
    waitingListJotformId: undefined,
    propertyGroup: "LEADS-OM",
  },
  faq: {
    banner: {
      image: "https://cdn.maxxpm.com/stockphotos/family smiling on bed.jpg",
    },
  },
};
